export default {
    name: 'Ime',
    tel: 'Telefon',
    save: 'Shrani',
    confirm: 'Potrdi',
    cancel: 'Prekliči',
    delete: 'Izbriši',
    complete: 'Zaključi',
    loading: 'Nalaganje...',
    telEmpty: 'Vnesite telefonsko številko',
    nameEmpty: 'Vnesite ime',
    nameInvalid: 'Neveljavno ime',
    confirmDelete: 'Ali res želite izbrisati?',
    telInvalid: 'Neveljavna telefonska številka',
    vanCalendar: {
        end: 'Konec',
        start: 'Začetek',
        title: 'Koledar',
        startEnd: 'Začetek/Konec',
        weekdays: ['Ned', 'Pon', 'Tor', 'Sre', 'Čet', 'Pet', 'Sob'],
        monthTitle: (year, month) => `${year}/${month}`,
        rangePrompt: (maxRange) => `Izberite največ ${maxRange} dni`,
    },
    vanCascader: {
        select: 'Izberi',
    },
    vanContactCard: {
        addText: 'Dodaj kontaktne podatke',
    },
    vanContactList: {
        addText: 'Dodaj nov kontakt',
    },
    vanPagination: {
        prev: 'Prejšnja',
        next: 'Naslednja',
    },
    vanPullRefresh: {
        pulling: 'Povlecite za osvežitev...',
        loosing: 'Spustite za osvežitev...',
    },
    vanSubmitBar: {
        label: 'Skupaj:',
    },
    vanCoupon: {
        unlimited: 'Neomejeno',
        discount: (discount) => `${discount * 10}% popust`,
        condition: (condition) => `Najmanj ${condition}`,
    },
    vanCouponCell: {
        title: 'Kupon',
        tips: 'Ni kupona',
        count: (count) => {
            if (count % 100 === 1) return `Imate ${count} kupon`;
            if (count % 100 === 2) return `Imate ${count} kupona`;
            if (count % 100 === 3 || count % 100 === 4) return `Imate ${count} kupone`;
            return `Imate ${count} kuponov`;
        },
    },
    vanCouponList: {
        empty: 'Ni kupona',
        exchange: 'Zamenjaj',
        close: 'Zapri',
        enable: 'Na voljo',
        disabled: 'Ni na voljo',
        placeholder: 'Koda kupona',
    },
    vanAddressEdit: {
        area: 'Območje',
        postal: 'Poštna številka',
        areaEmpty: 'Izberite dostavno območje',
        addressEmpty: 'Naslov ne sme biti prazen',
        postalEmpty: 'Napačna poštna številka',
        defaultAddress: 'Nastavi kot privzeti naslov',
        telPlaceholder: 'Telefon',
        namePlaceholder: 'Ime',
        areaPlaceholder: 'Območje',
    },
    vanAddressEditDetail: {
        label: 'Naslov',
        placeholder: 'Naslov',
    },
    vanAddressList: {
        add: 'Dodaj nov naslov',
    },
};